import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Grid, Paper, Typography } from "@mui/material";

// *import component
import MainMenu from "../../components/MainMenu";
import TitleBar from "../../components/TitleBar";
import ScoreboardTable from "./ScoreboardTable";

import { makeStyles } from "@mui/styles";
import ScoreboardTableEdit from "./ScoreboardEditTable";
import { useEffect } from "react";
import {
  getDmpLists,
  getSelectedDMPLeague,
} from "../../redux/actions/dmp-actions";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { apiPost } from "../../utils/apiRequests";
import ApiEndpoints from "../../utils/ApiEndpoints";

const useStyles = makeStyles({
  mainBox: {
    background: "#fff !important",
    minHeight: 800,
    boxShadow: "2px 4px 8px 0px #0000001A",
    boxSizing: "border-box",
    padding: "40px",
    marginTop: "30px",
  },
  card: {
    background: "#fff !important",
    marginTop: "2rem",
    minHeight: "60%",
    boxShadow: "0px 1.7378084659576416px 57.347679138183594px 0px #6F686833",
    borderRadius: "10px",
    paddingTop: "1.5em",
  },
  boxHeading: {
    textAlign: "center",
    marginBottom: "1em",
    fontSize: "25px !important",
    fontWeight: "bold !important",
  },
});

const Scoreboard = () => {
  const classes = useStyles();

  const { id } = useParams();
  const { state } = useLocation();
  const dispatch = useDispatch();

  const [isEdit, setIsEdit] = useState(false);
  const [members, setMembers] = useState([]);
  const [noOfRouned, setNoOfRounds] = useState(0);

  const aboutLeague = useSelector((state) => state.getDmpList.data);
  
  const selectedDMPSelector = useSelector(
    (state) => state.getSelectedDMPLeagueReducer.data
  );

  useEffect(() => {
    let body = {
      match_id: id,
      round_id: state._id,
    };
    apiPost("/api/league/getmatchscores", body, (res) => {
      setMembers(res.roundMatchData);
    });
  }, [aboutLeague]);

  useEffect(() => {
    dispatch(getSelectedDMPLeague(state.league_id));
  }, []);

  useEffect(() => {
    if (Object.keys(selectedDMPSelector).length !== 0) {
      setNoOfRounds(
        selectedDMPSelector?.leageData[0]?.season_description?.no_of_teams
      );
    }
  }, [selectedDMPSelector]);

  return (
    <MainMenu>
      <Paper className={classes.mainBox} elevation={3}>
        <TitleBar
          handleToggle={() => setIsEdit(!isEdit)}
          name="Double Match Play"
        />
        <Box className={classes.card}>
          <Typography className={classes.boxHeading}>
            DMP - Round of {noOfRouned}
          </Typography>
          {isEdit ? (
            <ScoreboardTableEdit members={members} setShow={setIsEdit} />
          ) : (
            <ScoreboardTable members={members} />
          )}
        </Box>
      </Paper>
    </MainMenu>
  );
};

export default Scoreboard;
